export default "__VITE_ASSET__4ef6186b__"